module.exports = __webpack_public_path__ + "img/img2.368f9252.svg";